"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _elementVariables = _interopRequireDefault(require("@/assets/styles/element-variables.scss"));
var _settings = _interopRequireDefault(require("@/settings"));
var _feildWidth = _interopRequireDefault(require("@/store/settings/feildWidth"));
var showSettings = _settings.default.showSettings,
  tagsView = _settings.default.tagsView,
  fixedHeader = _settings.default.fixedHeader,
  sidebarLogo = _settings.default.sidebarLogo,
  title = _settings.default.title;
var datetypewidth = _feildWidth.default.datetypewidth,
  datetimetypewidth = _feildWidth.default.datetimetypewidth,
  statewidth = _feildWidth.default.statewidth,
  namewidth = _feildWidth.default.namewidth,
  doctypewidth = _feildWidth.default.doctypewidth,
  docnumberwidth = _feildWidth.default.docnumberwidth,
  suppliernamewidth = _feildWidth.default.suppliernamewidth,
  customernamewidth = _feildWidth.default.customernamewidth,
  actorynamewidth = _feildWidth.default.actorynamewidth,
  whnamewidth = _feildWidth.default.whnamewidth,
  materielcodewidth = _feildWidth.default.materielcodewidth,
  materielnamewidth = _feildWidth.default.materielnamewidth,
  materialsggwidth = _feildWidth.default.materialsggwidth,
  unitwidth = _feildWidth.default.unitwidth,
  pricetypewidth = _feildWidth.default.pricetypewidth,
  valuetypewidth = _feildWidth.default.valuetypewidth,
  lineNumberWidth = _feildWidth.default.lineNumberWidth,
  serialWidth = _feildWidth.default.serialWidth,
  longTextWidth = _feildWidth.default.longTextWidth,
  phonewidth = _feildWidth.default.phonewidth,
  problemDescriptionWidth = _feildWidth.default.problemDescriptionWidth,
  titlenamewidth = _feildWidth.default.titlenamewidth;
var state = {
  title: title,
  theme: _elementVariables.default.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  // 字段宽度
  datetypewidth: datetypewidth,
  datetimetypewidth: datetimetypewidth,
  statewidth: statewidth,
  namewidth: namewidth,
  doctypewidth: doctypewidth,
  docnumberwidth: docnumberwidth,
  suppliernamewidth: suppliernamewidth,
  customernamewidth: customernamewidth,
  actorynamewidth: actorynamewidth,
  whnamewidth: whnamewidth,
  materielcodewidth: materielcodewidth,
  materielnamewidth: materielnamewidth,
  materialsggwidth: materialsggwidth,
  unitwidth: unitwidth,
  pricetypewidth: pricetypewidth,
  valuetypewidth: valuetypewidth,
  lineNumberWidth: lineNumberWidth,
  serialWidth: serialWidth,
  longTextWidth: longTextWidth,
  phonewidth: phonewidth,
  problemDescriptionWidth: problemDescriptionWidth,
  titlenamewidth: titlenamewidth
};
var mutations = {
  // eslint-disable-next-line no-shadow
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};